module.exports = __webpack_public_path__ + "img/game--fifa-22.b6694ae5.png";